import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Form, FormControl, Row } from "react-bootstrap";
import bgImage from "./../../../assets/venderlanding.webp";
import apple_ios from "../../../assets/apple.svg";
import google_play from "../../../assets/google_play.svg";
import {
  PLUS_ADD,
  MINUS,
} from "../../comman/components/CommonimagePath";
import { LazyLoadImage } from "react-lazy-load-image-component";
import mobile_landing from "./../../../assets/mobile_landing.png";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { fetchHeaderContent } from "../../seoroute/redux/actions";

function ContactusPage(props) {

  const { t } = useTranslation();
  const [inputValue, setInputvalue] = useState({ fullName: "", email: "", message: "" });
  const [errors, setErrors] = useState({ fullName: "", email: "", message: "" });
  const [quetionSelect, setQuetionSelect] = useState("");
  const emailRegex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

  useEffect(() => {
    props?.fetchHeaderContent(t("pages.meta.contact_us.title"), t("pages.meta.contact_us.description"),);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.language]);

  const quetions = [
    {
      text: t("pages.parter.quetions.q1"),
      description: "It only takes a few clicks to become a Girne partner. Simply sign up, enter your business information, and add your products, and your shop is ready to accept online orders.",
      descriptionTr: "Girne iş ortağı olmak için sadece birkaç tık yeterlidir. Kaydolun, işletme bilgilerinizi girin ve ürünlerinizi ekleyin; mağazanız çevrimiçi siparişleri kabul etmeye hazır."
    },
    {
      text: t("pages.parter.quetions.q2"),
      description: "It is completely free to create and run an online shop with Girne.",
      descriptionTr: "Girne ile bir online mağaza oluşturmak ve işletmek tamamen ücretsizdir."
    },
  ];

  const inputChange = (e) => {
    setInputvalue({
      ...inputValue,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validation = () => {
    let value = true;
    if (inputValue.fullName === "") {
      errors.fullName = "pages.parter.fullname_warn";
      value = false;
    }
    if (!inputValue.email.match(emailRegex)) {
      errors.email = "pages.parter.email_valid";
      value = false;
    }
    if (inputValue.email === "") {
      errors.email = "pages.parter.email_warn";
      value = false;
    }
    if (inputValue.message === "") {
      errors.message = "pages.chat.Enter Message";
      value = false;
    }
    setErrors({
      ...errors,
      fullName:errors.fullName,
      email:errors.email,
      message:errors.message
    })
    return value;
  }

  const getContactusRequest = async (payload) => {
    try {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      const callProfileupdate = await fetch(`${process.env.REACT_APP_BASE_URL}/api/contact-us`,
        {
          headers,
          method: "POST",
          body: JSON.stringify(payload),
        }
      );
      return callProfileupdate;
    } catch (error) { }
  }

  const submitContact = async (e) => {
    e.preventDefault();
    if (validation()) {
      let payload = {
        full_name: inputValue.fullName,
        email: inputValue.email,
        message: inputValue.message,
        lang:props.language.toLowerCase()
      }
      let getContactusResponse = await getContactusRequest(payload);
      if (getContactusResponse.status === 200) {
        let getResult = await getContactusResponse.json();
        toast.success(getResult?.msg);
        setInputvalue({
           fullName:"",
           email:"",
           message:""
        });
      }
    }
  }

  return (
    <>
      <div className="vendor_signup">
        <div className="signups">
          <div
            style={{ backgroundImage: `url('${bgImage}')` }}
            alt={""}
            className={"bg-signups"}
          >
            <Container className="pt-10 container-lg">
              <Row className="Signup">
                <div className="col-6">
                  <div className="contact-text">
                    <h5 className="first-text">{t("pages.Got Questions or Concerns?")}</h5>
                    <h3 className="second-text">{t("pages.Contact our Support Team for Immediate Assistance!")}</h3>
                  </div>
                </div>
                <div className="col-6 signup-card">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="header-title">
                      {t("pages.Contact With Us")}
                      </h5>
                      <p className="title-secound">
                      </p>
                      <Form className="forms">
                        <Row>
                          <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <FormControl
                              onChange={inputChange}
                              value={inputValue.fullName}
                              name={"fullName"}
                              className="sda"
                              placeholder={t("pages.parter.fullname")}
                              type={"text"}
                            />
                            <span className="text-danger">
                              {t(errors.fullName)}
                            </span>
                          </div>
                          <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <FormControl
                              onChange={inputChange}
                              value={inputValue.email}
                              name={"email"}
                              className="sda"
                              placeholder={t("pages.parter.email")}
                              type={"text"}
                            />
                            <span className="text-danger">
                              {t(errors.email)}
                            </span>
                          </div>
                          <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <FormControl
                              onChange={inputChange}
                              value={inputValue.message}
                              name={"message"}
                              className="sda"
                              placeholder={t("pages.chat.Enter Message")}
                              type={"text"}
                              as="textarea"
                              rows={5}
                              style={{height:"auto"}}
                            />
                            <span className="text-danger">
                              {t(errors.message)}
                            </span>
                          </div>
                          <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <button type="submit" className="primary-btn" onClick={(e) => submitContact(e)}>
                              {t("pages.Submit")}
                            </button>
                          </div>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </div>
              </Row>
            </Container>
          </div>
        </div>
        <div className="quetions ">
          <div className="text-center">
            <h5 className="text-5 pt-3 pb-3">
              {t("pages.parter.quetions.title")}.
            </h5>
          </div>
          <Container className={"container-lg"}>
            <Row className="step_row">
              {quetions.map((item, index) => (
                <div className="quetionslist">
                  <div
                    onClick={() =>
                      index === quetionSelect
                        ? setQuetionSelect("")
                        : setQuetionSelect(index)
                    }
                    className="collaps"
                  >
                    <h5>{item.text}</h5>
                    <img
                      src={quetionSelect === index ? MINUS : PLUS_ADD}
                      height="25"
                      width="25"
                      alt="minus"
                    ></img>
                  </div>
                  <div
                    className={
                      quetionSelect === index
                        ? "collaps-bottom show"
                        : "collaps-bottom"
                    }
                  >
                    <p>{props?.language === "Tr" ? item?.descriptionTr : item?.description}</p>
                  </div>
                </div>
              ))}
            </Row>
          </Container>
        </div>
        <div className="official">
          <div className="center">
            <h3 className="text-5 text-white">
              {t("pages.parter.playstore.title")}
            </h3>
            <p className="p-1 text-white">
              {t("pages.parter.playstore.subtitle")}
            </p>
            <div className="button_div">
              <button className="ios_btn" onClick={() => window.open("https://apps.apple.com/in/app/girne/id6444398214", "_blank")}>
                <img src={apple_ios} height="25" width="25" alt="IOS"></img>
                <div className="cols">
                  <span className="download">
                    {t("pages.parter.playstore.appstore_subtitle")}
                  </span>
                  <h5 className="titles">
                    {t("pages.home.appinfo.btn_2.title2")}
                  </h5>
                </div>
              </button>
              <button className="apk_btn" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.girne", "_blank")}>
                <img src={google_play} height="25" width="25" alt="GOOGLE" />
                <div className="cols">
                  <span className="download">
                    {t("pages.parter.playstore.play_subtitle")}
                  </span>
                  <h5 className="titles">
                    {t("pages.parter.playstore.play_title")}
                  </h5>
                </div>
              </button>
            </div>
            <label className="caption">
              {t("pages.parter.playstore.subtitle2")}
            </label>
            <div className="mobile-div">
              <LazyLoadImage
                src={mobile_landing}
                className={"mobile-images"}
                alt={""}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )

}

const mapStateToProps = (state) => ({
  language: state?.languageState?.language,
});

export default connect(mapStateToProps,{fetchHeaderContent})(ContactusPage);
